var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeneratorOrange({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.668C0 8.668 3.48292 8.52219 6.96585 8.52219C10.4488 8.52219 13.9317 8.668 13.9317 8.668V8.84532H0V8.668ZM0 9.28324C0 9.28324 3.48292 9.13742 6.96585 9.13742C10.4488 9.13742 13.9317 9.28324 13.9317 9.28324V9.46055H0V9.28324ZM0 9.69791C0 9.93328 0.192111 10.1211 0.423499 10.1107C1.45387 10.0646 4.20986 9.95425 6.96585 9.95425C9.72183 9.95425 12.4778 10.0646 13.5082 10.1107C13.7396 10.1211 13.9317 9.93328 13.9317 9.69791H0ZM7.03415 0C7.24735 0 8.06108 0.00469324 8.27348 0.00571905L6.64742 4.13839L5.6219 8.27522H0L0.0683093 0.145812C0.0683093 0.145812 3.55123 0 7.03415 0ZM13.9317 8.27522H5.6219L6.64742 4.13839L8.27348 0.00571905C11.2978 0.0326831 14 0.145812 14 0.145812L13.9317 8.27522ZM7.89697 2.33331L6.80452 3.92122L7.87433 3.90411L5.44445 6.76805L6.54925 4.30346L5.49111 4.31963L6.35848 2.33522L7.89697 2.33331Z",
    fill: "#E8913B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneratorOrange);
export default __webpack_public_path__ + "static/media/Generator_Orange.3d6fc5a68f9103fbd2d8de332ba953f8.svg";
export { ForwardRef as ReactComponent };